// extracted by mini-css-extract-plugin
export default {"overflow":"tooltipCell_overflow__N5PEx","ellipsis":"tooltipCell_ellipsis__cgV+q"};